<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>DESIGNATION<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="designations" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="designationColumns" [selectionField]="'Designation_Id'"
            [addEntityIcon]="'bi bi-plus-square'" [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'"
            (downloadEntities)="onExcelExport()" (addEntity)="addDesignation($event)"
            (editEntity)="editDesignation($event)" (refreshEntities)="refreshDesignation($event)"
            (deleteEntity)="deleteDesignation($event)" (onPaginationChange)="onPaginationChange($event)"
            [serverPagination]="true" [pageSizes]="pageSizes" [pageSize]="defaultPageSize" [skip]="pageSkip"
            (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearDesignation()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Designation Name'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                        [fieldName]="'DesignationName'" [(ngModel)]="entity.DesignationName"
                        ngDefaultControl></textbox>

                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'"  [mandatory]="true" [formData]="entity" [maxlength]="10"  [fieldName]="'Code'" 
                    [(ngModel)]="entity.Code" ngDefaultControl></textbox>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Designation Level'" [formData]="entity" [data]="designationlevel"
                        [class]="'form-control'" [mandatory]="false" [filterable]="true"
                        (filterChanged)="getAllDesignationLevels($event)" [(ngModel)]="entity.Designation_Level_Id"
                        [textField]="'DesignationLevelName'" [valueField]="'Designation_Level_Id'"
                        [fieldName]="'Designation_Level_Id'" [selectedItem]="selectedDesignationLevel" ngDefaultControl>
                    </dropdown>
                </div>
            </div> -->


            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-1">
                <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                    [type]="'button'" title="Back Tab"></btn>
            </div>
            <div class="col-md-4 mb-2">
                <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                    [type]="'button'"></btn>
            </div>
        </div> -->
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Designation Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="DesignationName" class="label label-1"> Designation Name : </label> {{details.DesignationName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Code" class="label label-1">Code : </label> {{details.Code}}
          </div>
        </div>
        </div>
    </kendo-dialog>
<kendo-excelexport [data]="designations.data" [collapsible]="true" fileName="Designation.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DesignationName" title="Designation" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Code" title="Code" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="DesignationLevelName" title="Designation Level" [width]="200">
    </kendo-excelexport-column> -->
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>